
export default {
  props: {
    formValue: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      formConfig: {
        labelWidth: '150px'
      },
      formItem: [{
        label: '选择测试人员：',
        type: 'business',
        subtype: 'tester-selector',
        prop: 'tester_id',
        rules: [{
          required: true,
          message: '请选择测试人员',
          trigger: 'change'
        }]
      }]
    };
  },

  methods: {
    validate: function validate() {
      return this.$refs['form'].validate();
    }
  }
};